import { CustomerInfo } from '@/domain/CustomerInfo'
import { Customer } from '@/domain/Customer'
import axios from 'axios'

/**
 * 顧客サービス
 */
export default class CustomersService {
    /** インスタンス */
    private static _instance: CustomersService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new CustomersService();
        }
        return this._instance;
    }

    /**
     * 新規作成
     */
    public async createNew(): Promise<Customer> {
        return await axios.get("/api/customer/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(prefectureCode: string, code: string, branchNumber: string): Promise<Customer> {
        return await axios.get(`/api/customer/edit/${prefectureCode}/${code}/${branchNumber}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: Customer): Promise<Customer> {
        return await axios.post("/api/customer/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: Customer): Promise<Customer> {
        return await axios.put(`/api/customer/edit/${dto.pk.prefectureCode}/${dto.pk.code}/${dto.pk.branchNumber}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 表示
     */
    public async show(prefectureCode: string, code: string, branchNumber: string): Promise<Customer> {
        return await axios.get(`/api/customer/show/${prefectureCode}/${code}/${branchNumber}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 顧客の代理店取得
     */
    public async agency(prefectureCode: string, code: string, branchNumber: string): Promise<Customer> {
        return await axios.get(`/api/customer/show/${prefectureCode}/${code}/${branchNumber}/agency`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 全件取得
     */
    public async findAll(): Promise<CustomerInfo[]> {
        return await axios.get("/api/customers")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as CustomerInfo[]).map(x => new CustomerInfo({ ...x }))
                } else {
                    return []
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                return []
            })
    }

    /**
     * 代表全件取得
     */
    public async findRepresentativeAll(): Promise<CustomerInfo[]> {
        return await axios.get("/api/customers/representative")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as CustomerInfo[]).map(x => new CustomerInfo({ ...x }))
                } else {
                    return []
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                return []
            })
    }

    /**
     * 代理店全件取得
     */
    public async findAgencyAll(): Promise<CustomerInfo[]> {
        return await axios.get("/api/customers/agency")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as CustomerInfo[]).map(x => new CustomerInfo({ ...x }))
                } else {
                    return []
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                return []
            })
    }

    /**
     * 合算請求対象全件取得
     */
    public async findInvoiceAll(): Promise<CustomerInfo[]> {
        return await axios.get("/api/customers/invoice")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as CustomerInfo[]).map(x => new CustomerInfo({ ...x }))
                } else {
                    return []
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                return []
            })
    }

    /**
     * 顧客区分年次更新
     */
    public async annualUpdate(): Promise<number> {
        return await axios.put("/api/customers/annual_update")
            .then((results) => {
                if (results.status === 200) {
                    return results.data
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Customer {
        const customer = data as Customer
        return new Customer({ ...customer })
    }
}
